interface TrackingPropertiesParams {
  isSddRecurring: boolean;
  addressWasPrefilled: boolean;
  scheduleType: string;
  scheduleTotalCollectionCount: number;
}

type Platform = 'mobile' | 'web';

const detectPlatform = (): Platform => {
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  return isMobile ? 'mobile' : 'web';
};

export const createTrackingProperties = (params: TrackingPropertiesParams) => {
  const { isSddRecurring, addressWasPrefilled, scheduleType, scheduleTotalCollectionCount } =
    params;

  return (shouldIncludeDuration: boolean): Record<string, string | boolean> => {
    const platform = detectPlatform();

    const properties: Record<string, string | boolean> = {
      collection_type: isSddRecurring ? 'recurring' : 'one-off',
      platform,
      address_prefilled: addressWasPrefilled,
    };

    if (isSddRecurring) {
      properties.frequency = scheduleType;
      if (shouldIncludeDuration) {
        properties.duration = scheduleTotalCollectionCount === 0 ? 'no_limit' : 'number_payments';
      }
    }

    return properties;
  };
};
